import createGallery from './gallery';
import createGalleryPager from './gallery-pager';
import renderDetailView from './creative-challenge-entry-detail';

/**
 * A browser for the creative challenge galleries.
 *
 * This class is responsible for rendering the creative challenge galleries, and handling the
 * navigation between the different galleries and pages.
 *
 *
 * @param {CreativeChallengeDataManager} dataManager
 *  The data manager for the creative challenge galleries.
 * @param {Object} options
 *  The options for the creative challenge browser.
 * @param {number} options.itemsPerPage
 *  The number of items to display per page.
 */
export default class CreativeChallengeBrowser {
  constructor(dataManager, options = {}) {
    this.dataManager = dataManager;
    this.$element = $('<div></div>')
      .addClass('creative-challenge-browser');
    const defaultOptions = {
      itemsPerPage: 12 * 6,
    };
    this.options = { ...defaultOptions, ...options };

    this.currentGalleryId = null;
    this.currentPageNumber = null;

    this.destroyGallery = () => {};
  }

  async init() {
    this.installRouteListener();
    return this.update();
  }

  installRouteListener() {
    // If there's no hash, set the default gallery
    if (!window.location.hash) {
      window.location.hash = `#${this.dataManager.getDefaultGallery()}/1`;
    }
    $(window).on('hashchange', () => {
      this.update();
    });
  }

  getGalleryFromHash() {
    const pathParts = window.location.hash.substring(1).split('/');
    return this.dataManager.isValidGalleryId(pathParts[0])
      ? pathParts[0]
      : this.dataManager.getDefaultGallery();
  }

  // eslint-disable-next-line class-methods-use-this
  getPageNumberFromHash() {
    const pathParts = window.location.hash.substring(1).split('/');
    return pathParts[1] || 1;
  }

  async update() {
    if (this.currentGalleryId === this.getGalleryFromHash()
      && this.currentPageNumber === this.getPageNumberFromHash()) {
      return Promise.resolve();
    }

    this.currentGalleryId = this.getGalleryFromHash();
    this.currentPageNumber = this.getPageNumberFromHash();

    return this.dataManager.getGalleryData(this.currentGalleryId).then((item) => {
      const pageCount = item.length / this.options.itemsPerPage;
      const pageItems = item.slice(
        (this.currentPageNumber - 1) * this.options.itemsPerPage,
        this.currentPageNumber * this.options.itemsPerPage
      );
      pageItems.forEach((pageItem) => {
        // eslint-disable-next-line no-param-reassign
        pageItem.route = `#${this.currentGalleryId}/${this.currentPageNumber}/${this.dataManager.getPhotoRoutePrefix()}${pageItem.id}`;
      });

      this.destroyGallery();
      this.$element.empty();
      if (pageCount > 1) {
        this.$element.append(createGalleryPager(
          this.currentGalleryId,
          Math.ceil(item.length / this.options.itemsPerPage),
          Number(this.currentPageNumber)
        ));
      }
      const galleryContainer = $('<div></div>').appendTo(this.$element);
      if (pageCount > 1) {
        const bottomPager = createGalleryPager(
          this.currentGalleryId,
          Math.ceil(item.length / this.options.itemsPerPage),
          Number(this.currentPageNumber)
        );
        this.$element.append(bottomPager);
        bottomPager.find('a').on('click', () => {
          window.scrollTo(0, 0);
        });
      }
      this.destroyGallery = createGallery(galleryContainer, pageItems, renderDetailView, {
        modalSize: 'xl',
        modalClass: 'photo-challenge-modal',
      });
    });
  }
}
